module.exports = __webpack_public_path__ + "83db7eebc648800c235be4ea4d6d5766.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/plunger-hat.png
// module id = 2321
// module chunks = 0